import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import LiveSportsList from "./LiveSportsList";

const LiveSports = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Live Sports" />
          <div>
            <LiveSportsList />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LiveSports;
